/**
 * Public marketing / SEO landings where we delay GTM + wallet adapters
 * so Lighthouse TBT is not dominated by third-party JS.
 */
export function isPerfSensitiveMarketingPath(pathname) {
  if (!pathname) return false;
  const path = pathname.split("?")[0].replace(/\/$/, "") || "/";
  if (path === "/") return true;
  return (
    path === "/volume-bot" ||
    path === "/solana-market-maker" ||
    path === "/pumpfun-volume-bot" ||
    path === "/raydium-volume-bot" ||
    path === "/orca-volume-bot" ||
    path === "/meteora-volume-bot" ||
    path === "/idx-volume-bot" ||
    path === "/holders-maker" ||
    path === "/reaction-booster" ||
    path === "/idx-launchlab"
  );
}
